import React, { FC, useCallback } from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { ICartEntryType } from 'state/loyalty/in-restaurant-redemption';

import { BadgeAndIncrementor } from './badge-and-incrementor';
import {
  OfferItemDescription,
  OfferItemName,
  OfferItemPicture,
  RewardItemDescription,
  RewardItemName,
  RewardItemPicture,
} from './map-components';
import {
  InRestaurantRedemptionEntryContainer,
  InRestaurantRedemptionEntryContent,
  PictureAndDetails,
  RewardDetails,
  StyledIconX,
  WrapperName,
} from './reward-redemption.styled';
import { IRewardRedemptionItemProps, ViewComponentMapping } from './types';

const componentMapping: ViewComponentMapping = {
  [ICartEntryType.OFFER]: {
    // @ts-expect-error TS(2322) FIXME: Type 'FC<IItemPictureProps<"offer">>' is not assig... Remove this comment to see the full error message
    ItemPicture: OfferItemPicture,
    // @ts-expect-error TS(2322) FIXME: Type 'FC<IItemNameProps<"offer">>' is not assignab... Remove this comment to see the full error message
    ItemName: OfferItemName,
    // @ts-expect-error TS(2322) FIXME: Type 'FC<IItemDescriptionProps<"offer">>' is not a... Remove this comment to see the full error message
    ItemDescription: OfferItemDescription,
  },
  [ICartEntryType.LEGACY_OFFER]: {
    // @ts-expect-error TS(2322) FIXME: Type 'FC<IItemPictureProps<"offer">>' is not assig... Remove this comment to see the full error message
    ItemPicture: OfferItemPicture,
    // @ts-expect-error TS(2322) FIXME: Type 'FC<IItemNameProps<"offer">>' is not assignab... Remove this comment to see the full error message
    ItemName: OfferItemName,
    // @ts-expect-error TS(2322) FIXME: Type 'FC<IItemDescriptionProps<"offer">>' is not a... Remove this comment to see the full error message
    ItemDescription: OfferItemDescription,
  },
  [ICartEntryType.REWARD]: {
    // @ts-expect-error TS(2322) FIXME: Type 'FC<IItemPictureProps<"reward">>' is not assi... Remove this comment to see the full error message
    ItemPicture: RewardItemPicture,
    // @ts-expect-error TS(2322) FIXME: Type 'FC<IItemNameProps<"reward">>' is not assigna... Remove this comment to see the full error message
    ItemName: RewardItemName,
    // @ts-expect-error TS(2322) FIXME: Type 'FC<IItemDescriptionProps<"reward">>' is not ... Remove this comment to see the full error message
    ItemDescription: RewardItemDescription,
  },
};

export const RewardRedemptionItem: FC<React.PropsWithChildren<IRewardRedemptionItemProps>> = ({
  cartEntry,
  handleUpdateEntry,
  handleRemoveEntry,
}) => {
  const { formatMessage } = useIntl();

  const handleRemove = useCallback(() => {
    handleRemoveEntry(cartEntry);
  }, [cartEntry, handleRemoveEntry]);

  const { details, type } = cartEntry;
  const components = componentMapping[type];

  const { ItemPicture, ItemName, ItemDescription } = components;

  return (
    <InRestaurantRedemptionEntryContainer newUI={false}>
      <InRestaurantRedemptionEntryContent>
        <PictureAndDetails>
          <ItemPicture entryCartDetails={details} objectFitContain />

          <RewardDetails>
            <WrapperName>
              <ItemName entryCartDetails={details} />
            </WrapperName>
            <ItemDescription entryCartDetails={details} />

            <BadgeAndIncrementor cartEntry={cartEntry} handleUpdateEntry={handleUpdateEntry} />
          </RewardDetails>
        </PictureAndDetails>

        <Pressable
          onPress={handleRemove}
          padding={'$4'}
          accessibilityRole="button"
          accessibilityLabel={formatMessage({ id: 'removeItem' })}
          testID="remove-item"
        >
          <StyledIconX />
        </Pressable>
      </InRestaurantRedemptionEntryContent>
    </InRestaurantRedemptionEntryContainer>
  );
};
